import React from "react";

import { SubscriptionContext } from "../../../../services/SubscriptionService";
import PlayerInjury from "../../PlayerInjury";
import { UpgradeToView } from "../../RowComponents";

/**
 * Display the injuries of the team.
 *
 * @param game {any} the game to get injuries for
 * @param isHome {boolean}: is this the home team
 */
const teamInjuries = (game: any, isHome?: boolean) => {
  const { injuredPlayers } = game[isHome ? "homeTeam" : "awayTeam"];
  let filteredPlayers: any[] = [];
  if (injuredPlayers) {
    filteredPlayers = injuredPlayers.filter((injuredPlyr: any) => !!injuredPlyr.news);
  }
  if (filteredPlayers.length > 0) {
    return filteredPlayers.map((plyrInjury: any, index: number) => {
      const {
        fullName,
        position,
        news: { title, newsTime },
      } = plyrInjury;
      return <PlayerInjury key={index} name={fullName} position={position} newsTitle={title} newsTime={newsTime} />;
    });
  }
  return (
    <div className="games-table-column__injury_container">
      <span className="games-table-column__injury-text">No {isHome ? "home" : "away"} team injuries</span>
    </div>
  );
};

/**
 * Render the Fullgame spread movement cell
 *
 * @param game The game to get the date from
 * @param index The index for the key
 */
export const getInjuriesCell = (game: any, index: number, showDraw: boolean) => (
  <React.Fragment key={index}>
    <SubscriptionContext.Consumer>
      {({ signedIn }) => {
        const showStat: boolean = game.freeGame || signedIn;
        if (showStat) {
          return (
            <div
              className={`games-table-column__news-injuries-cell ${
                showDraw ? "games-table-column__news-injuries-cell--draw" : ""
              }`}
            >
              {teamInjuries(game)}
              <div className="games-table-column__divider" />
              {teamInjuries(game, true)}
            </div>
          );
        } else {
          return (
            <UpgradeToView
              className={`games-table-column__news-injuries-cell ${
                showDraw ? "games-table-column__news-injuries-cell--draw" : ""
              }`}
              showText={true}
              trackingProps={{
                screen: "FeedView",
                page: "Games Table",
                source: "Injuries Cell",
                sport: game.league.name,
                gameId: game.id,
                awayTeam: game.awayTeam.fullName,
                homeTeam: game.homeTeam.fullName,
              }}
            />
          );
        }
      }}
    </SubscriptionContext.Consumer>
  </React.Fragment>
);
